import { useSelector } from 'react-redux';
import { getFinanceProviderUrl } from 'src/redux/app/selectors';

export default function useCodeweaversApiKey() {
  const url = useSelector(getFinanceProviderUrl);

  return () => new URL(url).searchParams.get('ApiKey');
}
